<template>
  <div
    class="Header"
    :class="{ isAuthenticated }">
    <div
      class="mobile-nav"
      v-if="isAuthenticated"
      @click="$emit('nav-toggle')">
      <Icon name="bars" />
    </div>
    <Logo />
    <h1>PT dashboard</h1>
    <div
      v-if="isAuthenticated"
      class="profile">
      <Avatar />
      <div
        class="menu"
        @click="showMenu = !showMenu">
        <div class="fullname">
          {{ firstName }} {{ lastName }}
          <Icon
            name="arrow"
            direction="down" />
        </div>
        <span class="mobile-nav"><Icon name="overflow" /></span>
      </div>
      <DropdownMenu
        v-if="showMenu"
        @close="toggleMenu()">
        <li @click="logout()">
          <Icon name="send" />
          <span>Logout</span>
        </li>
      </DropdownMenu>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo";
import Avatar from "@/components/Avatar";
import DropdownMenu from "@/components/DropdownMenu";
import { mapGetters } from "vuex";

export default {
  components: { Logo, Avatar, DropdownMenu },

  data: function () {
    return {
      showMenu: false,
    };
  },

  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    logout() {
      this.$router.push("logout");
    },
  },

  computed: {
    ...mapGetters([
      "isAuthenticated",
      "profile"
      ]),
    firstName() {
      return this.profile.firstName;
    },
    lastName() {
      return this.profile.lastName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/responsive";
.Header {
  position: sticky;
  top: 0;
  padding-left: 1em;
  padding-top: 1em;
  padding-bottom: 1em;
  align-items: center;
  flex: 1;
  display: flex;
  background-color: var(--midnight-blue);
  color: white;

  h1 {
    padding-left: 0.5em;
    flex: 1;
  }

  .fullname {
    display: flex;
    align-items: center;
  }

  .profile {
    display: flex;
    align-items: center;
    margin-left: auto;
    padding: 1em;
    font-weight: bold;
    font-size: 0.857em;

    .menu {
      cursor: pointer;
    }

    .Avatar {
      margin-right: 0.5em;
    }

    .logout {
      cursor: pointer;
    }
  }
  // media queries
  .mobile-nav {
    display: none;
    cursor: pointer;
  }

  @include phone {
    &.isAuthenticated {
      padding-top: 0;
      padding-bottom: 0;

      .Logo,
      h1 {
        display: none;
      }
      .Avatar {
        display: none;
      }
      .fullname {
        display: none;
      }
    }
    .mobile-nav {
      display: inherit;
    }
  }
}
</style>
